<template>
  <button
    class="flex items-center gap-1 text-sm whitespace-nowrap"
    data-gtm-action="show nutrition info"
    :data-gtm-label="product.title"
    @click.prevent="modalActive = true"
  >
    <slot>
      {{ product.protein }} {{ $t('products.protein') }}
      |
      {{ product.calories }} {{ $t('products.cal') }}
      <svg-icon
        name="info"
        class="w-3 h-3 text-blue-500"
      />
    </slot>
  </button>
  <VueModal
    v-if="product"
    v-model="modalActive"
    @close="modalActive = false"
  >
    <ProductNutritionModal
      :product="product"
      @close="modalActive = false"
    />
  </VueModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import VueModal from '@/components/theme/render/vue-modal.vue'
import ProductNutritionModal from '@/components/products/product-nutrition-modal.vue'
import type { Product } from '@/types/shopify'
export interface Props {
  product: Product
}
defineProps<Props>()
const modalActive = ref(false)
</script>
